<!-- Icons used in the component -->
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
     style="position: absolute; width: 0; height: 0" id="__SVG_SPRITE_NODE__">
    <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 5" id="chevron-down">
        <path
            d="M9,0.7c0,0.1,0,0.2-0.1,0.2l-4.2,4C4.6,5,4.4,5,4.3,4.9c0,0,0,0,0,0l-4.2-4C0,0.8,0,0.6,0.1,0.5c0,0,0,0,0,0  l0.4-0.4C0.6,0,0.8,0,0.9,0.1c0,0,0,0,0,0l3.5,3.4L8,0.1C8.1,0,8.3,0,8.4,0.1c0,0,0,0,0,0l0.5,0.4C9,0.6,9,0.6,9,0.7z"></path>
    </symbol>
</svg>

<security-input
    class="text-input"
    [(ngModel)]="securityKey"
    (ngModelChange)="onSecurityChange($event)">
</security-input>
